import LegalDocsPage from './LegalDocsPage';

export default LegalDocsPage;
